<template>
  <div class="content-page">
    <div class="tab-content">
      <div class="step-container">
        <el-steps :active="currStep" simple finish-status="success">
          <el-step title="1. 创建活动"></el-step>
          <el-step title="2. 奖项设置"></el-step>
          <el-step title="3. 页面装修"></el-step>
        </el-steps>
      </div>

      <div class="setting-container">
        <div class="views-content">
          <div style="position: relative">
            <img
              class="lottery-bg"
              :src="form.bkImage || require('@/assets/img/lottery/img_01.png')"
              alt=""
            />
            <img class="lottery-title" src="@/assets/img/lottery/img_02.png" alt="" />
            <img class="lottery-content" src="@/assets/img/lottery/img_03.png" alt="" />
            <div class="lottery-prize">
              <div class="lottery-prize-item" v-for="item in prizeList">
                <img class="prize-img" :src="item.lotteryPrizeImage" alt="" />
                <div class="prize-name">{{ item.prizeName }}</div>
              </div>
            </div>
            <div class="lottery-panel" v-if="form.isShowWinnerList == 1">
              <div class="panel-title">中奖名单</div>
              <div>
                <div class="panel-item">
                  <div class="panel-item-user">
                    <span class="panel-item-user-name">中奖用户</span>
                    <span class="panel-item-user-date">2024-02-23 18:36:45</span>
                  </div>

                  <div class="panel-item-prize">获得300积分</div>
                </div>
                <div class="panel-item">
                  <div class="panel-item-user">
                    <span class="panel-item-user-name">中奖用户</span>
                    <span class="panel-item-user-date">2024-02-23 20:56:36</span>
                  </div>

                  <div class="panel-item-prize">获得优惠券</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currStep == 1" class="lottery-position">
            <img src="@/assets/img/lottery/img_06.png" alt="" />
          </div>
        </div>

        <!-- 基础设置 -->
        <div class="base-content" v-if="currStep == 0">
          <div class="title">基本信息</div>
          <el-form ref="form1" :model="form" :rules="rules1" label-width="120px">
            <el-form-item label="活动名称" prop="activityTitle">
              <el-input v-model="form.activityTitle" style="width: 400px"></el-input>
            </el-form-item>

            <el-form-item label="活动时间" prop="date">
              <el-date-picker
                v-model="form.date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <!-- <el-form-item label="抽奖形式">
              <el-radio-group v-model="form.lotteryFormat" v-removeAria>
                <el-radio :label="1">九宫格</el-radio>
                <el-radio :label="2">盲盒</el-radio>
              </el-radio-group>
              <span style="color: red; margin-left: 10px">(支付宝小程序不支持)</span>
            </el-form-item> -->

            <el-form-item label="展示位置">
              <el-radio-group v-model="form.displayPosition" v-removeAria>
                <el-radio :label="1">首页</el-radio>
                <el-radio :label="2">支付结果页</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="参与条件">
              <div style="display: flex">
                <el-checkbox v-model="isTaste">每次消抽奖消耗</el-checkbox>
                <el-input-number
                  style="width: 100px; margin-left: 10px"
                  v-model="form.consumePoint"
                  controls-position="right"
                  :min="1"
                  :max="100"
                >
                </el-input-number>
                <span style="margin-left: 10px">积分</span>
              </div>
            </el-form-item>

            <el-form-item label="基础抽奖次数">
              <el-checkbox-group v-model="form.typeList" :min="1">
                <div>
                  <el-checkbox label="type1">
                    <span>每人每天抽</span>
                  </el-checkbox>
                  <el-input-number
                    style="width: 100px; margin-left: 10px"
                    v-model="form.dayLimitTimesValue"
                    controls-position="right"
                    :min="0"
                    :max="99"
                  >
                  </el-input-number>
                </div>
                <div style="margin-top: 10px">
                  <el-checkbox label="type2">
                    <span>每人一共抽 </span>
                  </el-checkbox>
                  <el-input-number
                    style="width: 100px; margin-left: 10px"
                    v-model="form.activityLimitTimesValue"
                    controls-position="right"
                    :min="0"
                    :max="99"
                  >
                  </el-input-number>
                </div>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="中奖次数">
              <el-radio-group v-model="form.radio" v-removeAria>
                <div>
                  <el-radio :label="1">无限制</el-radio>
                </div>
                <div>
                  <el-radio :label="2">
                    <span>每人最多抽中 </span>
                  </el-radio>
                  <el-input-number
                    style="width: 100px; margin-left: 10px"
                    v-model="form.winLimit"
                    controls-position="right"
                    :min="0"
                    :max="99"
                  >
                  </el-input-number>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>

        <!-- 奖品设置 -->
        <div class="prize-content" v-else-if="currStep == 1">
          <div class="title">奖品设置</div>
          <div>
            <div>
              <span class="add-prize" @click="openDialog()">添加奖品</span>
              <span>（{{ form.lotteryPrizeJson.length }} / 7）</span>
            </div>
            <el-table
              :data="form.lotteryPrizeJson"
              style="width: 100%; margin-top: 20px; margin-bottom: 20px"
              :header-cell-style="{
                fontSize: '14px',
                backgroundColor: '#f8f8f8',
                color: '#333',
              }"
            >
              <el-table-column prop="prizeName" label="名称" width="180">
              </el-table-column>
              <el-table-column prop="prizeType" label="奖品类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">积分</span>
                  <span v-if="scope.row.prizeType == 3">赠品</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="totalStock" label="发放总量">
                            </el-table-column> -->
              <el-table-column prop="lotteryPrizeImage" label="转盘图片">
                <template slot-scope="scope">
                  <template>
                    <img
                      :src="
                        scope.row.lotteryPrizeImage ||
                        'https://img01.yzcdn.cn/upload_files/2021/12/15/Fkh8SQovBkzCiA7Pyw0ujNTMUdsY.png!small.webp'
                      "
                      alt=""
                      style="height: 50px; width: 50px"
                    />
                  </template>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click="updatePrize(scope.row)"
                    >编辑</el-button
                  >
                  <el-button type="danger" size="small" @click="deletePrize(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="title">未中奖设置</div>
          <div>
            <el-form ref="form2" :rules="rules3" :model="form" label-width="100px">
              <el-form-item label="名称：" prop="notWinningName">
                <el-input
                  v-model="form.notWinningName"
                  style="width: 200px"
                  :maxlength="5"
                ></el-input>
              </el-form-item>

              <el-form-item label="图片：">
                <el-upload
                  action="/YmUpload_image"
                  :limit="1"
                  list-type="picture-card"
                  :class="{ disabled: uploadDisabled2 }"
                  :before-upload="beforeCoverUpload"
                  :on-error="imgError2"
                  :on-remove="handleCoverRemove2"
                  :http-request="handleSuccessImg2"
                  accept=".jpeg,.jpg,.png,.bmp,.gif"
                  :file-list="prizeFileList"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div>不上传，则使用默认图片</div>
              </el-form-item>

              <el-form-item label="提示语：">
                <el-input v-model="form.notWinningPrompt" style="width: 200px"></el-input>
              </el-form-item>

              <el-form-item label="提示跳转：" v-if="false">
                <el-radio-group v-model="jumpType" v-removeAria>
                  <div>
                    <el-radio :label="1">无跳转</el-radio>
                  </div>
                  <div style="margin-top: 15px">
                    <el-radio :label="2">
                      <span>有跳转 </span>
                    </el-radio>
                    <el-cascader
                      :disabled="jumpType != 2"
                      v-model="value"
                      :options="options"
                      :props="{ expandTrigger: 'hover' }"
                      @change="handleChange"
                    ></el-cascader>
                  </div>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>

          <div class="title">转盘设置</div>
          <div style="padding-bottom: 100px">
            <el-table
              :data="form.turntableJson"
              style="width: 50%; margin-top: 20px; margin-bottom: 20px"
              :header-cell-style="{
                fontSize: '14px',
                backgroundColor: '#f8f8f8',
                color: '#333',
              }"
            >
              <el-table-column prop="position" label="转盘位置"> </el-table-column>

              <el-table-column align="center" prop="prizeName" label="奖品">
                <template slot-scope="scope">
                  <el-select
                    placeholder="请选择"
                    v-model="scope.row.prizeName"
                    @change="prizeChange($event, scope.row)"
                    :disabled="scope.$index == 7"
                  >
                    <el-option
                      v-for="item in choosePrizeList"
                      :key="item.customId"
                      :value="item.prizeName"
                      :label="item.prizeName"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="image" label="转盘图片">
                <template slot-scope="scope">
                  <template>
                    <img :src="scope.row.lotteryPrizeImage" alt="" style="height: 50px" />
                  </template>
                </template>
              </el-table-column>

              <el-table-column align="center" label="转到概率(%)" width="230px">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.probability"
                    :precision="2"
                    :step="1"
                    :max="100"
                    :min="0"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="page-decoration" v-else>
          <div class="title">基础设置</div>
          <el-form ref="form2" :model="form" :rules="rules3" label-width="120px">
            <el-form-item label="背景图片：">
              <el-upload
                action="/YmUpload_image"
                :limit="1"
                list-type="picture-card"
                :class="{ disabled: uploadDisabled3 }"
                :before-upload="beforeCoverUpload"
                :on-error="imgError3"
                :http-request="handleSuccessImg3"
                :on-remove="handleCoverRemove3"
                accept=".jpeg,.jpg,.png,.bmp,.gif"
                :file-list="bgfileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div>
                <div style="line-height: 30px">建议上传尺寸750px*1624px</div>
                <div style="line-height: 30px">不上传，则使用默认图片</div>
              </div>
            </el-form-item>
            <el-form-item label="背景色：">
              <el-color-picker v-model="form.bkColor"></el-color-picker>
            </el-form-item>
            <el-form-item label="中奖名单：">
              <el-radio-group v-model="form.isShowWinnerList" v-removeAria>
                <el-radio :label="1">展示</el-radio>
                <el-radio :label="0">不展示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="玩法规则">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
                style="width: 200px"
                :maxlength="100"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="button-container">
        <el-button v-if="currStep == 0" type="info" size="mini" @click="handleCancel"
          >取消</el-button
        >
        <el-button v-else type="primary" size="mini" @click="handleTop" plain
          >上一步</el-button
        >
        <el-button
          v-if="currStep < 2"
          type="primary"
          size="mini"
          @click="handleNext"
          plain
          >下一步</el-button
        >
        <el-button
          v-else-if="currStep == 2"
          type="primary"
          size="mini"
          @click="handleSave"
          >保存</el-button
        >
      </div>
    </div>

    <el-dialog title="设置奖品" :visible.sync="isShow" width="30%" @close="onClose">
      <div>
        <el-form ref="dialogForm" :model="dialogForm" :rules="rules2" label-width="120px">
          <el-form-item label="奖品名称：" prop="prizeName">
            <el-input
              v-model="dialogForm.prizeName"
              style="width: 200px"
              placeholder="最多可填写5个字"
              :maxlength="5"
            ></el-input>
          </el-form-item>

          <el-form-item label="奖品内容：">
            <el-radio-group ref="radio" v-model="dialogForm.prizeType" v-removeAria>
              <el-radio :label="1" :disabled="isDisabled">优惠券</el-radio>
              <el-radio :label="2" :disabled="isDisabled">积分</el-radio>
              <el-radio :label="3" :disabled="isDisabled">赠品</el-radio>
            </el-radio-group>

            <div v-if="dialogForm.prizeType == 1">
              <span
                v-if="!currentCoupon.title"
                class="chooseText"
                @click="showDialogCoupon = true"
                >选择优惠券</span
              >
              <div v-else>
                <span>已选择：</span>
                <span>{{ currentCoupon.title }}</span>
                <span
                  v-if="!isDisabled"
                  class="chooseText"
                  @click="showDialogCoupon = true"
                >
                  重新选择</span
                >
              </div>
            </div>

            <div v-else-if="dialogForm.prizeType == 2">
              <el-input
                v-model="dialogForm.scorePoint"
                style="width: 100px"
                type="number"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                :disabled="isDisabled"
              ></el-input>
              <span> 积分</span>
            </div>

            <div v-else-if="dialogForm.prizeType == 3">
              <span
                v-if="!confirmList.goodsName"
                class="chooseText"
                @click="dialogGoodsSel = true"
                >选择赠品</span
              >
              <div v-else>
                <span>已选择：</span>
                <span>{{
                  confirmList.goodsName +
                  (confirmList.valueContent ? "（" + confirmList.valueContent + "）" : "")
                }}</span>
                <span
                  v-if="!isDisabled"
                  class="chooseText"
                  @click="dialogGoodsSel = true"
                >
                  重新选择</span
                >
              </div>
            </div>
          </el-form-item>

          <!-- <el-form-item label="发放总量：">
                        <el-input v-model="dialogForm.totalStock" style="width: 200px;" type="number"
                            oninput="value=value.replace(/[^0-9.]/g,'')" disabled></el-input>
                        <span> 份</span>
                    </el-form-item> -->

          <el-form-item label="图片：">
            <el-upload
              :disabled="imgDisabled"
              action="/YmUpload_image"
              :limit="1"
              list-type="picture-card"
              :class="{ disabled: uploadDisabled }"
              :before-upload="beforeCoverUpload"
              :on-success="handleCoverSuccess"
              :on-error="imgError"
              :http-request="handleSuccessImg"
              :on-remove="handleCoverRemove"
              accept=".jpeg,.jpg,.png,.bmp,.gif"
              :file-list="fileList"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'goodsImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <div>不上传，则使用默认图片</div>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="addPrize">确 定</el-button>
      </span>
    </el-dialog>

    <dialog-sel-goods
      :isShow="dialogGoodsSel"
      @hideSelGoods="hideSelGoods"
      @confirmSelGoods="confirmSelGoods"
    >
    </dialog-sel-goods>

    <dialog-coupon
      :isShow="showDialogCoupon"
      @hideDialogCoupon="hideDialogCoupon"
      @confirmCoupon="confirmCoupon"
    >
    </dialog-coupon>

    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    >
    </uploadImgComponent>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》'
import dialogSelGoods from "@/components/dialogSelGoods.vue";
import dialogCoupon from "@/components/dialogCoupon.vue";
import uploadImgComponent from "@/components/uploadImg";
import dayjs from "dayjs";
import { nanoid } from "nanoid";
import { uploadImg, addLotteryActivity, getLotteryDetail } from "../api/index";

export default {
  components: {
    dialogSelGoods,
    dialogCoupon,
    uploadImgComponent,
  },
  props: [],
  data() {
    return {
      currStep: 0,
      jumpType: 1,

      defaultPrizeImg:
        "https://img01.yzcdn.cn/upload_files/2021/12/15/Fkh8SQovBkzCiA7Pyw0ujNTMUdsY.png!small.webp",
      defaultImg: "https://img01.yzcdn.cn/luckydraw/ths.png!small.webp",

      isshow_uploadDialog: false,
      imgDisabled: false,
      ImgLimits: 0,
      uploadName: "",

      isTaste: false, // 是否消耗积分

      // 创建活动表单
      form: {
        activityId: "", // 活动id
        activityTitle: "", // 活动名称
        lotteryFormat: 1, // 活动类型
        displayPosition: 1, // 展示位置

        date: [],
        startTime: "", // 开始时间
        endTime: "", // 结束时间

        consumePoint: "", // 消耗积分
        typeList: ["type1"], // 基础抽奖次数
        dayLimitTimesValue: 1,
        activityLimitTimesValue: "",

        radio: 1,
        winLimit: "", // 中奖次数

        lotteryPrizeJson: [], // 奖品列表
        turntableJson: [], // 转盘设置列表

        notWinningName: "谢谢参与", // 未中奖名称
        notWinningPrompt: "你离中奖只差一丢丢", // 未中奖提示
        notWinningImage: "", // 未中奖图片
        notWinningJump: "", // 未中奖跳转

        bkImage: "", // 背景图片
        bkColor: "#DF1F57", // 背景颜色
        isShowWinnerList: 0, // 中奖名单 1 显示 0 不显示
        description: "", // 玩法规则
      },
      rules1: {
        activityTitle: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        date: [{ required: true, message: "请设置活动时间", trigger: "blur" }],
      },

      // 添加奖品弹窗表单
      dialogForm: {
        customId: "",
        prizeType: 1, // 奖品类型 -1=优惠券 2=积分 3=赠品
        prizeName: "",
        scorePoint: "", // 积分数
        totalStock: 1, // 发放总量
        lotteryPrizeImage: "", // 图片
        prizeId: "", // 奖品id
        originName: "", // 奖品名称
        originStock: "", // 奖品库存
      },
      rules2: {
        prizeName: [{ required: true, message: "请输入奖品名称", trigger: "blur" }],
      },

      rules3: {
        notWinningName: [
          { required: true, message: "请输入未中奖名称", trigger: "blur" },
        ],
      },

      value: [],
      options: [],

      isShow: false,
      dialogImageUrl: "",
      uploadDisabled: false,
      dialogImgVisible: false,
      fileList: [],

      uploadDisabled2: false,
      prizeFileList: [],

      uploadDisabled3: false,
      bgfileList: [],

      dialogGoodsSel: false,
      confirmList: {},

      showDialogCoupon: false,
      currentCoupon: {},

      // 展示奖品列表
      prizeList: [
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
        {
          name: "谢谢参与",
          img: "https://img01.yzcdn.cn/luckydraw/ths.png",
        },
      ],

      choosePrizeList: [], // 可选择的奖品列表

      isDisabled: false, // 是否禁用

      pickerOptions: {
        disabledDate: (time) => {
          // 禁用今天之前的日期选择
          return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  computed: {},
  watch: {
    "form.typeList": {
      handler(newV, oldV) {
        if (newV.length == 2) {
          if (newV[1] == "type1") {
            this.form.dayLimitTimesValue = this.form.dayLimitTimesValue || 1;
          } else {
            this.form.activityLimitTimesValue = this.form.activityLimitTimesValue || 1;
          }
        } else {
          if (newV[0] == "type1") {
            this.form.activityLimitTimesValue = "";
          } else {
            this.form.dayLimitTimesValue = "";
          }
        }
      },
    },
    "form.radio": {
      handler(newV, oldV) {
        if (newV == 1) {
          this.form.winLimit = "";
        } else {
          this.form.winLimit = this.form.winLimit || 1;
        }
      },
    },

    "dialogForm.prizeType": {
      handler(newV, oldV) {
        if (newV == 2) {
          this.confirmList = {};
          this.currentCoupon = {};
          this.dialogForm.prizeId = "";
          this.dialogForm.originName = "";
          this.dialogForm.originStock = "";
        } else {
          if (newV == -1) {
            this.confirmList = {};
          } else if (newV == 3) {
            this.currentCoupon = {};
          }

          this.dialogForm.scorePoint = "";
        }
      },
    },

    jumpType: {
      handler(newV, oldV) {
        if (newV == 1) {
          this.form.notWinningJump = "";
        }
      },
    },

    "form.notWinningName": {
      handler(newV, oldV) {
        this.form.turntableJson.forEach((item) => {
          if (item.customId == 0) {
            item.prizeName = newV;
          }
        });

        this.prizeList.forEach((item) => {
          if (item.customId == 0) {
            item.prizeName = newV;
          }
        });

        this.choosePrizeList.forEach((item) => {
          if (item.customId == 0) {
            item.prizeName = newV;
          }
        });
      },
    },

    "form.notWinningImage": {
      handler(newV, oldV) {
        if (newV != "" && newV != this.defaultImg) {
          this.prizeFileList = [];
          this.prizeFileList.push({ url: newV });
        }

        this.form.turntableJson.forEach((item) => {
          if (item.customId == 0) {
            item.lotteryPrizeImage = newV;
          }
        });

        this.prizeList.forEach((item) => {
          if (item.customId == 0) {
            item.lotteryPrizeImage = newV;
          }
        });
      },
    },

    "form.bkImage": {
      handler(newV, oldV) {
        if (newV != "") {
          this.bgfileList = [];
          this.bgfileList.push({ url: newV });
        } else {
          this.bgfileList = [];
          this.uploadDisabled3 = false;
        }
      },
    },
  },

  async mounted() {
    if (!this.$route.query.activityId) {
      // 新增
      // this.form.date = [new Date(), new Date()];
      // this.form.startTime = new Date();
      // this.form.endTime = new Date();

      // 初始化8个空奖品
      for (let i = 1; i < 9; i++) {
        this.form.turntableJson.push({
          customId: 0,
          position: i,
          prizeName: "谢谢参与",
          probability: 0,
          isDefault: i == 8 ? 1 : 0,
          lotteryPrizeImage: this.defaultImg,
        });
      }
      let temp = JSON.stringify(this.form.turntableJson);
      this.prizeList = JSON.parse(temp);
    } else {
      await this.getDetail(this.$route.query.activityId);
    }

    // 中间的设置成开始抽奖图片
    this.prizeList.splice(4, 0, {
      lotteryPrizeImage: require("@/assets/img/lottery/img_04.png"),
      prizeName: "",
    });

    this.choosePrizeList.unshift({
      customId: 0,
      prizeName: this.form.notWinningName || "谢谢参与",
      probability: 0,
      lotteryPrizeImage: this.form.notWinningImage || this.defaultImg,
    });
  },

  methods: {
    async getDetail(id) {
      try {
        const tempData = {
          shopId: localStorage.shopId,
          activityId: id,
        };
        const res = await getLotteryDetail(tempData);
        if (res.code == 1) {
          // 设置活动时间
          if (res.data.startTime) {
            this.form.date.push(new Date(res.data.startTime));
            this.form.date.push(new Date(res.data.endTime));
          }
          if (res.data.consumePoint > 0) {
            this.isTaste = true;
          }
          // 设置基础抽奖次数
          if (res.data.dayLimitTimesValue > 0) {
            this.form.typeList = ["type1"];
          }
          if (res.data.activityLimitTimesValue > 0) {
            this.form.typeList.push("type2");
          }
          // 设置中奖次数
          if (res.data.winLimit > 0) {
            this.form.radio = 2;
          }

          this.form.activityId = res.data.id;
          this.form.activityTitle = res.data.activityTitle;
          this.form.startTime = res.data.startTime;
          this.form.endTime = res.data.endTime;
          this.form.dayLimitTimesValue = res.data.dayLimitTimesValue;
          this.form.activityLimitTimesValue = res.data.activityLimitTimesValue;
          this.form.winLimit = res.data.winLimit;
          this.form.consumePoint = res.data.consumePoint;
          this.form.lotteryFormat = res.data.lotteryFormat;
          this.form.displayPosition = res.data.displayPosition;

          if (res.data.notWinningImage != this.defaultImg) {
            this.uploadDisabled2 = true;
            this.prizeFileList.push({ url: res.data.notWinningImage });
          }

          this.form.lotteryPrizeJson = JSON.parse(res.data.lotteryPrizeJson);
          this.form.turntableJson = JSON.parse(res.data.turntableJson);
          this.form.notWinningName = res.data.notWinningName;
          this.form.notWinningPrompt = res.data.notWinningPrompt;
          this.form.notWinningImage = res.data.notWinningImage;
          this.form.notWinningJump = res.data.notWinningJump;

          if (res.data.bkImage != "") {
            this.uploadDisabled3 = true;
            this.bgfileList.push({ url: res.data.bkImage });
          }

          this.form.bkImage = res.data.bkImage;
          this.form.bkColor = res.data.bkColor;
          this.form.isShowWinnerList = res.data.isShowWinnerList;
          this.form.description = res.data.description;
        }

        // TODO
        let temp1 = JSON.stringify(this.form.turntableJson);
        this.prizeList = JSON.parse(temp1);

        let temp2 = JSON.stringify(this.form.lotteryPrizeJson);
        this.choosePrizeList = JSON.parse(temp2);
      } catch (error) {
        console.log(error);
      }
    },

    // 日期格式转换
    dateChange() {
      if (this.form.date) {
        this.form.startTime = dayjs(this.form.date[0]).format("YYYY-MM-DD HH:mm:ss");
        this.form.endTime = dayjs(this.form.date[1]).format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
    },

    // 打开添加奖品
    openDialog(params) {
      if (!params && this.form.lotteryPrizeJson.length == 7) {
        this.$message({
          message: "奖品最多添加 7 个",
          type: "warning",
        });
        return;
      }
      if (params) {
        if (params.lotteryPrizeImage != this.defaultPrizeImg) {
          this.fileList = [];
          this.fileList.push({ url: params.lotteryPrizeImage });
          this.uploadDisabled = true;
        }

        if (params.prizeType == 1) {
          this.currentCoupon.id = params.prizeId;
          this.currentCoupon.title = params.originName;
          this.currentCoupon.totalCount = params.originStock;
        } else if (params.prizeType == 3) {
          this.confirmList.goodsId = params.prizeId;
          this.confirmList.goodsName = params.originName;
          this.confirmList.valueContent = params.originStock;
        }
        Object.assign(this.dialogForm, params);
      }

      this.isShow = true;
    },

    // 添加奖品
    addPrize() {
      if (this.dialogForm.prizeType == 1 && !this.currentCoupon.id) {
        this.$message({
          message: "请选择优惠券",
          type: "warning",
        });
        return;
      }

      if (this.dialogForm.prizeType == 2 && this.dialogForm.scorePoint == "") {
        this.$message({
          message: "请填写赠送积分数",
          type: "warning",
        });
        return;
      }

      if (this.dialogForm.prizeType == 3 && !this.confirmList.goodsId) {
        this.$message({
          message: "请选择赠品",
          type: "warning",
        });
        return;
      }

      this.$refs["dialogForm"].validate((valid) => {
        if (valid) {
          if (!this.isDisabled) {
            let isSame = this.form.lotteryPrizeJson.findIndex(
              (item) => item.prizeName == this.dialogForm.prizeName
            );
            if (isSame != -1) {
              this.$message({
                message: "奖品名称已存在",
                type: "warning",
              });
              return;
            }

            // 新增
            const tempData = {
              shopId: localStorage.shopId,
              prizeId: this.dialogForm.prizeId,
              customId: this.createId(), // 生成唯一id
              originName: this.dialogForm.originName,
              originStock: this.dialogForm.originStock,
              prizeName: this.dialogForm.prizeName,
              prizeType: this.dialogForm.prizeType,
              scorePoint: this.dialogForm.scorePoint,
              totalStock: this.dialogForm.totalStock,
              lotteryPrizeImage: this.dialogForm.lotteryPrizeImage,
            };
            if (tempData.lotteryPrizeImage == "") {
              tempData.lotteryPrizeImage = this.defaultPrizeImg;
            }

            this.form.lotteryPrizeJson.push(tempData);
            this.choosePrizeList.push(tempData);
          } else {
            // 编辑
            const index = this.form.lotteryPrizeJson.findIndex(
              (item) => item.customId == this.dialogForm.customId
            );

            this.form.lotteryPrizeJson[index].prizeName = this.dialogForm.prizeName;
            this.form.lotteryPrizeJson[index].totalStock = this.dialogForm.totalStock;
            this.form.lotteryPrizeJson[
              index
            ].lotteryPrizeImage = this.dialogForm.lotteryPrizeImage;

            this.choosePrizeList[index + 1].prizeName = this.dialogForm.prizeName;
            this.choosePrizeList[index + 1].totalStock = this.dialogForm.totalStock;
            this.choosePrizeList[
              index + 1
            ].lotteryPrizeImage = this.dialogForm.lotteryPrizeImage;

            this.form.turntableJson.forEach((item) => {
              if (item.customId == this.dialogForm.customId) {
                item.prizeName = this.dialogForm.prizeName;
                item.lotteryPrizeImage = this.dialogForm.lotteryPrizeImage;
              }
            });

            this.prizeList.forEach((item) => {
              if (item.customId == this.dialogForm.customId) {
                item.prizeName = this.dialogForm.prizeName;
                item.lotteryPrizeImage = this.dialogForm.lotteryPrizeImage;
              }
            });
          }

          Object.assign(this.dialogForm, this.$options.data().dialogForm);
          this.isShow = false;
        } else {
          this.$message({
            message: "请输入必填信息",
            type: "warning",
          });
        }
      });
    },

    // 关闭添加奖品
    onClose() {
      this.uploadDisabled = false;
      this.fileList = []; // 清空图片
      this.confirmList = {}; // 清空赠品
      this.currentCoupon = {}; // 清空优惠券
      Object.assign(this.dialogForm, this.$options.data().dialogForm);
      this.isShow = false;
      this.isDisabled = false;
    },

    show_uploadDialog(val, name) {
      this.ImgLimits = val;
      this.uploadName = name;
      if (this.dialogForm.prizeType == 3) {
        this.imgDisabled = true;
        this.isshow_uploadDialog = true;
      }
    },
    close_uploadDialog() {
      this.imgDisabled = false;
      this.isshow_uploadDialog = false;
    },
    getChoose_ImgUrl(arr, name) {
      this.fileList = [];
      this.fileList.push({ url: arr[0].image });

      this.dialogForm.lotteryPrizeImage = arr[0].image;

      this.uploadDisabled = true;
      this.imgDisabled = false;
      this.isshow_uploadDialog = false;
    },

    // 编辑奖品
    updatePrize(params) {
      this.isDisabled = true;
      this.openDialog(params);
    },

    // 删除奖品
    deletePrize(params) {
      this.form.lotteryPrizeJson = this.form.lotteryPrizeJson.filter(
        (item) => item.customId != params.customId
      );
      this.choosePrizeList = this.choosePrizeList.filter(
        (item) => item.customId != params.customId
      );

      this.form.turntableJson.forEach((item) => {
        if (item.customId == params.customId) {
          item.customId = 0;
          item.prizeName = this.form.notWinningName || "谢谢参与";
          item.probability = 0;
          item.lotteryPrizeImage = this.form.notWinningImage || this.defaultImg;
        }
      });

      this.prizeList.forEach((item) => {
        if (item.customId == params.customId) {
          item.customId = 0;
          item.prizeName = this.form.notWinningName || "谢谢参与";
          item.probability = 0;
          item.lotteryPrizeImage = this.form.notWinningImage || this.defaultImg;
        }
      });
    },

    confirmSelGoods(confirmList) {
      this.hideSelGoods();

      this.confirmList = confirmList;

      this.dialogForm.prizeId = this.confirmList.goodsId;
      this.dialogForm.originName = this.confirmList.goodsName;
      this.dialogForm.originStock = this.confirmList.valueContent;

      this.dialogForm.prizeName = this.confirmList.goodsName.slice(0, 5);
      this.dialogForm.lotteryPrizeImage = this.confirmList.goodsImage;

      this.fileList = [];
      this.fileList.push({ url: this.confirmList.goodsImage });
      this.uploadDisabled = true;
    },
    // 隐藏物品弹窗
    hideSelGoods() {
      this.dialogGoodsSel = false;
    },

    confirmCoupon(coupon) {
      this.showDialogCoupon = false;
      this.currentCoupon = coupon;

      this.dialogForm.prizeId = this.currentCoupon.id;
      this.dialogForm.originName = this.currentCoupon.title;
      this.dialogForm.originStock = this.currentCoupon.totalCount;
    },
    // 隐藏优惠券弹窗
    hideDialogCoupon() {
      this.showDialogCoupon = false;
    },

    handleChange(value) {
      console.log(value);
    },

    // 设置奖品发生改变
    prizeChange(prizeName, params) {
      const index = this.choosePrizeList.findIndex((item) => item.prizeName == prizeName);

      let i = this.prizeList.findIndex((item) => item.position == params.position);

      this.prizeList[i].prizeId = this.choosePrizeList[index].prizeId || "";
      this.prizeList[i].customId = this.choosePrizeList[index].customId;
      this.prizeList[i].prizeName = this.choosePrizeList[index].prizeName;
      this.prizeList[i].prizeType = this.choosePrizeList[index].prizeType;
      this.prizeList[i].lotteryPrizeImage = this.choosePrizeList[index].lotteryPrizeImage;
      this.prizeList[i].scorePoint = this.choosePrizeList[index].scorePoint;

      params.prizeId = this.choosePrizeList[index].prizeId || "";
      params.customId = this.choosePrizeList[index].customId;
      params.prizeName = this.choosePrizeList[index].prizeName;
      params.prizeType = this.choosePrizeList[index].prizeType;
      params.lotteryPrizeImage = this.choosePrizeList[index].lotteryPrizeImage;
      params.scorePoint = this.choosePrizeList[index].scorePoint;
    },

    handleInput(value) {
      if (value.length > 3) value = value.slice(0, 2);
      console.log(value);
      return value.replace(/^(0+)|[^\d]+/g, "");
    },

    handleCancel() {
      this.$router.back();
    },
    handleTop() {
      this.currStep--;
    },
    handleNext() {
      if (this.currStep == 0) {
        if (this.isTaste && !this.form.consumePoint) {
          this.$message({
            message: "请输入消耗积分数（大于0）",
            type: "warning",
          });
          return;
        }
        if (this.form.typeList.indexOf("type1") != -1 && !this.form.dayLimitTimesValue) {
          this.$message({
            message: "请输入每人每天抽的次数（大于0）",
            type: "warning",
          });
          return;
        }
        if (
          this.form.typeList.indexOf("type2") != -1 &&
          !this.form.activityLimitTimesValue
        ) {
          this.$message({
            message: "请输入每人一共抽的次数（大于0）",
            type: "warning",
          });
          return;
        }

        if (this.form.radio == 2 && !this.form.winLimit) {
          this.$message({
            message: "请输入每人最多抽中的次数（大于0）",
            type: "warning",
          });
          return;
        }

        if (
          this.form.typeList.indexOf("type1") != -1 &&
          this.form.typeList.indexOf("type2") != -1
        ) {
          if (this.form.dayLimitTimesValue > this.form.activityLimitTimesValue) {
            this.$message({
              message: "每人每天抽取数应小于等于一共抽取数",
              type: "warning",
            });
            return;
          }
        }

        this.$refs["form1"].validate((valid) => {
          if (valid) {
            this.currStep++;
          } else {
            this.$message({
              message: "请输入必填信息",
              type: "warning",
            });
          }
        });
      } else if (this.currStep == 1) {
        if (this.form.lotteryPrizeJson.length < 1) {
          this.$message({
            message: "请添加奖品",
            type: "warning",
          });
          return;
        }

        this.$refs["form2"].validate((valid) => {
          if (valid) {
            let sum = 0;
            this.form.turntableJson.forEach((item) => {
              sum += item.probability;
            });
            if (sum > 100) {
              this.$message({
                message: "所有奖品的总概率不能超过100%",
                type: "warning",
              });
            } else {
              this.currStep++;
            }
          } else {
            this.$message({
              message: "请输入必填信息",
              type: "warning",
            });
          }
        });
      }
    },
    // 保存
    async handleSave() {
      try {
        const tempData = {
          shopId: localStorage.shopId,
          activityId: this.form.activityId,
          activityTitle: this.form.activityTitle,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          lotteryFormat: this.form.lotteryFormat,
          displayPosition: this.form.displayPosition,
          consumePoint: this.isTaste ? this.form.consumePoint : "",
          dayLimitTimesValue:
            this.form.dayLimitTimesValue == 0 ? "" : this.form.dayLimitTimesValue,
          activityLimitTimesValue:
            this.form.activityLimitTimesValue == 0
              ? ""
              : this.form.activityLimitTimesValue,
          winLimit: this.form.winLimit,
          lotteryPrizeJson: JSON.stringify(this.form.lotteryPrizeJson),
          turntableJson: JSON.stringify(this.form.turntableJson),
          notWinningName: this.form.notWinningName,
          notWinningImage: this.form.notWinningImage || this.defaultImg,
          notWinningPrompt: this.form.notWinningPrompt,
          notWinningJump: this.form.notWinningJump,
          bkImage: this.form.bkImage,
          bkColor: this.form.bkColor,
          isShowWinnerList: this.form.isShowWinnerList,
          description: this.form.description,
        };

        const res = await addLotteryActivity(tempData);
        if (res.code == 1) {
          this.$message({
            message: "操作成功",
            type: "warning",
          });
          this.$router.back();
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      } catch (error) {
        this.$message({
          message: "操作失败",
          type: "warning",
        });
        console.log(error);
      }
    },

    // 上传封面前
    beforeCoverUpload(file) {
      if (
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/bmp" ||
        file.type == "image/gif"
      ) {
      } else {
        this.$message.error("文件类型错误");
        return false;
      }
    },

    // 成功上传封面
    handleCoverSuccess(res, file) {
      this.uploadDisabled = true;
      this.dialogForm.lotteryPrizeImage = file.response.data.url;
    },

    handleSuccessImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.dialogForm.lotteryPrizeImage = res.data.url;
          this.uploadDisabled = true;
        }
      });
    },

    // 上传失败
    imgError() {
      this.uploadDisabled = false;
    },

    // 移除封面
    handleCoverRemove() {
      this.uploadDisabled = false;
      this.dialogForm.lotteryPrizeImage = this.defaultPrizeImg;
    },

    // 成功上传封面2
    handleCoverSuccess2(res, file) {
      this.uploadDisabled2 = true;
      this.form.notWinningImage = file.response.data.url;
    },

    handleSuccessImg2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.form.notWinningImage = res.data.url;
          this.uploadDisabled2 = true;
        }
      });
    },

    // 上传失败2
    imgError2() {
      this.uploadDisabled2 = false;
    },

    // 移除封面2
    handleCoverRemove2() {
      this.uploadDisabled2 = false;
      this.form.notWinningImage = this.defaultImg;
      this.prizeFileList = [];
    },

    // 成功上传封面
    // handleCoverSuccess3(res, file) {
    //     this.uploadDisabled3 = true;
    //     this.form.bkImage = file.response.data.url;
    // },

    handleSuccessImg3(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.form.bkImage = res.data.url;
          this.uploadDisabled3 = true;
        }
      });
    },

    // 上传失败
    imgError3() {
      this.uploadDisabled3 = false;
    },

    // 移除封面
    handleCoverRemove3() {
      this.uploadDisabled3 = false;
      this.form.bkImage = "";
      this.bgfileList = [];
    },

    // 生成唯一id
    createId() {
      let customId = nanoid(7);
      let isfind = this.form.lotteryPrizeJson.findIndex(
        (item) => item.customId == customId
      );
      if (isfind == -1) {
        return customId;
      } else {
        this.createId();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tab-content {
  position: relative;
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  padding: 20px;
}

// 进步器
.step-container {
  width: 100%;
}

// 设置
.setting-container {
  display: flex;

  margin-top: 20px;

  .views-content {
    position: relative;
    margin-right: 20px;

    .lottery-bg {
      width: 375px;
      height: 740px;
    }

    .lottery-title {
      position: absolute;
      height: 80px;
      left: 50%;
      top: 110px;
      transform: translate(-50%, -50%);
    }

    .lottery-content {
      position: absolute;
      height: 400px;
      left: 50%;
      top: 360px;
      transform: translate(-50%, -50%);
    }

    .lottery-prize {
      position: absolute;
      left: 50%;
      top: 335px;
      transform: translate(-50%, -50%);

      width: 200px;
      height: 200px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      &-item {
        width: 60px;
        height: 60px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        background: url("../assets/img/lottery/img_05.png") no-repeat;
        background-size: contain;

        .prize-img {
          width: 30px;
          height: 30px;
        }

        .prize-name {
          width: 60px;

          font-weight: 500;
          font-size: 12px;
          text-align: center;
        }
      }

      &-item:nth-child(5) {
        background: none;

        .prize-img {
          width: 59px;
          height: 59px;
          margin-top: 0;
          margin-bottom: 0;
        }
      }
    }

    .lottery-panel {
      position: absolute;
      bottom: 15px;
      left: 50%;

      transform: translate(-50%, 0);

      height: 150px;
      width: 350px;
      background: #fff;
      border-radius: 10px;

      .panel-title {
        height: 25px;
        width: 200px;
        margin: auto;

        line-height: 25px;
        text-align: center;
        color: #f34900;
        background-color: rgba(243, 73, 0, 0.1);

        box-sizing: border-box;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .panel-item {
        display: flex;
        justify-content: space-between;

        box-sizing: border-box;
        padding: 15px;

        &-user {
          display: flex;
          flex-direction: column;

          &-name {
            font-size: 13px;
            line-height: 18px;
            color: #323233;
          }

          &-date {
            margin-top: 2px;
            font-size: 10px;
            line-height: 15px;
            color: #969799;
          }
        }

        &-prize {
          box-sizing: border-box;
          min-width: 62px;
          margin-left: 6px;
          font-size: 12px;
          line-height: 26px;
          text-align: center;
          font-weight: 500;
          color: #f34900;
        }
      }
    }

    .lottery-position {
      margin-top: 110px;

      display: flex;
      justify-content: center;
    }
  }

  .base-content {
    width: 100%;

    .title {
      box-sizing: border-box;
      padding: 15px 0;

      font-weight: 700;

      width: 100%;
      border-bottom: 1px solid #eee;

      margin-bottom: 20px;
    }
  }

  .prize-content {
    width: 100%;

    .title {
      box-sizing: border-box;
      padding: 15px 0;

      font-weight: 700;

      width: 100%;
      border-bottom: 1px solid #eee;

      margin-bottom: 20px;
    }

    .add-prize {
      color: rgb(31, 107, 248);
      cursor: pointer;
    }
  }

  .page-decoration {
    width: 100%;

    .title {
      box-sizing: border-box;
      padding: 15px 0;

      font-weight: 700;

      width: 100%;
      border-bottom: 1px solid #eee;

      margin-bottom: 20px;
    }
  }
}

.chooseText {
  color: rgb(31, 107, 248);
  cursor: pointer;
}

// 按钮
.button-container {
  position: fixed;
  z-index: 1;
  left: 0;
  bottom: 0;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  padding: 10px 0;

  background-color: #eee;
}
</style>
